import { styles } from "@repo/helpers";

import { Props } from "./types";

export function ImageDisplay(props: Props) {
	return (
		<img
			className={styles("img-rounded", "img-thumbnail")}
			style={props.style}
			src={props.value?.url}
			alt="Captured"
		/>
	);
}
